/**
 * lib/local/zip-path.ts — where a typed ZIP goes (FRIDGE-805).
 * Pure: the route looks the ZIP up in zip_energy_data and hands the row here.
 */
import { getStateSlug, isValidStateCode } from '@/lib/state-utils'

export const ZIP_RE = /^\d{5}$/

export function normalizeZip(input: string | null | undefined): string | null {
  const z = (input ?? '').trim().slice(0, 5)
  return ZIP_RE.test(z) ? z : null
}

/** `/local/<state>/<city>/<zip>` for a known row; null when the row cannot be placed. */
export function localPathForZip(row: { zip: string; state_code: string | null; city_slug: string | null } | null | undefined): string | null {
  if (!row || !ZIP_RE.test(row.zip)) return null
  const code = (row.state_code ?? '').toUpperCase()
  const city = (row.city_slug ?? '').trim()
  if (!isValidStateCode(code) || !/^[a-z0-9-]+$/.test(city)) return null
  return `/local/${getStateSlug(code)}/${city}/${row.zip}`
}
